import React, { useEffect, useState } from "react";
import { ImagePath } from "../../../assets/ImagePath";
import OtpVerify from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";
import { useLocation } from "react-router-dom";
import { getDomainConfig } from "../../../utils/DomainsHelper";


const OtpVerifyPage = () => {
  const location = useLocation();
  const state = location.state || {};
  const [bgImage, setBgImage] = useState("");

  console.log("State from navigation:", state.forgotPasswordOtp);
  console.log("Is Forgot Password OTP?", state.email);
   
   useEffect(() => {
    const config = getDomainConfig();
     setBgImage(config.banner);
   },[])
   
  return (
    <AuthLayout
      email={state.email}
      LeftComponent={OtpVerify}
      rightBgImage={bgImage}
      forgotPasswordOtp={state.forgotPasswordOtp}
    />
  );
};

export default OtpVerifyPage;